import { createLogger } from './logger.js'

const logger = createLogger('Browser')

/**
 * 浏览器检测工具函数
 */

/**
 * 检测是否是微信浏览器
 * @returns {boolean} 是否是微信浏览器
 */
export function isWeChatBrowser() {
  const ua = navigator.userAgent.toLowerCase()
  return /micromessenger/.test(ua)
}

/**
 * 检测是否是移动设备
 * @returns {boolean} 是否是移动设备
 */
export function isMobile() {
  return /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(
    navigator.userAgent.toLowerCase()
  )
}

/**
 * 获取浏览器类型
 * @returns {string} 浏览器类型 (wechat, mobile, desktop)
 */
export function getBrowserType() {
  if (isWeChatBrowser()) {
    return 'wechat'
  }
  if (isMobile()) {
    return 'mobile'
  }
  return 'desktop'
}

/**
 * 安全解码查询参数值（保留 + 为字面量，避免非法 % 序列抛错）
 * @param {string} rawValue
 * @returns {string}
 */
function decodeQueryValue(rawValue) {
  if (rawValue == null) return ''
  const prepared = String(rawValue).replace(/\+/g, '%2B')
  try {
    return decodeURIComponent(prepared)
  } catch {
    return String(rawValue).replace(/\+/g, ' ')
  }
}

/**
 * 从一段查询字符串（不含前导 ?）中解析指定参数
 * @param {string} queryString - 如 "code=abc&foo=1"
 * @param {string} paramName
 * @returns {string|null}
 */
function getParamFromQueryString(queryString, paramName) {
  if (!queryString) return null
  const pairs = queryString.split('&')
  for (const pair of pairs) {
    if (!pair) continue
    const [key, ...valueParts] = pair.split('=')
    if (key === paramName) {
      const value = valueParts.join('=')
      return decodeQueryValue(value)
    }
  }
  return null
}

/**
 * 从 URL 获取查询参数：先读 location.search，再读 hash 内查询串（兼容内嵌浏览器 / 部分 App WebView 把参数写在 # 后）
 * @param {string} paramName - 参数名
 * @returns {string|null} 参数值，如果不存在则返回 null
 */
export function getQueryParam(paramName) {
  const fromSearch = getParamFromQueryString(
    window.location.search ? window.location.search.substring(1) : '',
    paramName
  )
  logger.info('getQueryParam fromSearch:', fromSearch)
  if (fromSearch != null && fromSearch !== '') return fromSearch

  // hash 形如 #/?code=xx、#/upload?code=xx、#/path?code=xx&share=yy
  const hash = window.location.hash || ''
  const qIndex = hash.indexOf('?')
  if (qIndex !== -1) {
    const hashQuery = hash.slice(qIndex + 1)
    const fromHash = getParamFromQueryString(hashQuery, paramName)
    logger.info('getQueryParam fromHash:', fromHash)
    if (fromHash != null && fromHash !== '') return fromHash
  }

  return null
}

/**
 * 从 Vue Router 的 query 对象取参数（部分环境下仅 route.query 能拿到 code）
 * @param {Record<string, string|string[]|undefined>} query
 * @param {string} paramName
 * @returns {string|null}
 */
export function getQueryParamFromRouteQuery(query, paramName) {
  if (!query || query[paramName] == null) return null
  const v = query[paramName]
  const s = Array.isArray(v) ? v[0] : v
  if (s == null || String(s).trim() === '') return null
  logger.info('getQueryParamFromRouteQuery:', s)
  return String(s)
}

